import { useState } from 'react';
import { Content, Text, Col, Row, ModalLayout } from 'components';
import { Button, List, Tag, Modal, Flex, Select } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { SearchWordApi } from 'api';
import { useQueryClient } from '@tanstack/react-query';
import MessageAlert from 'utils';
import moment from 'moment';
import styled from 'styled-components';
import SearchWordModifyPopup from './SearchWordModifyPopup';
import { styles } from '../styles';
import { useUpdateSearchWord } from 'hooks/SearchWordHooks';
const SearchWordList = ({
  searchWordList,
  setSearchWordList,
  selectedSearchWord,
  onChangeSelectedSearchWord,
  onModal,
  dataList,
  setDataList,
  modalType,
  setIsLoading,
}) => {
  const [modifyPopupInfo, setModifyPopupInfo] = useState({
    isOpen: false,
    defaultData: null,
  });
  const queryClient = useQueryClient();
  /* ===== Mutate ===== */
  const { upsertSearchWord } = useUpdateSearchWord();

  const handleClickSearchWord = (searchWord) => {
    if (searchWord) {
      onChangeSelectedSearchWord(searchWord);
    }
  };

  const handleUpdateSearchWord = (searchWord) => {
    setModifyPopupInfo({
      isOpen: true,
      defaultData: searchWord,
    });
  };

  const handleDeleteSearchWord = (searchWord) => {
    Modal.confirm({
      title: '정말 이 추천검색어를 삭제하시겠습니까?',
      content: `삭제 추천검색어 : ${searchWord.search_word}`,
      okText: '삭제',
      onOk: async () => {
        if (searchWord.search_word_id) {
          const response = await SearchWordApi.deleteSearchWord(
            searchWord.search_word_id
          );

          if (response && response.status === 200) {
            MessageAlert.success('추천검색어를 삭제하였습니다.');
            queryClient.resetQueries({ queryKey: ['searchWord'] });
          } else {
            MessageAlert.error('추천검색어 삭제 중 오류가 발생하였습니다.');
          }
        }
      },
      cancelText: '취소',
      onCancel() {},
    });
  };

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const confirm = (msg = '') => window.confirm(msg);
      if (!confirm('순서를 변경 하시겠습니까?')) return;

      const response = await SearchWordApi.upsertSearchWord(data);
      if (response && response.status === 200) {
        MessageAlert.success('순서 변경을 성공하였습니다.');
        queryClient.resetQueries({ queryKey: ['searchWord'] });
        setSearchWordList(response?.data);
        setTimeout(() => {
          onModal('close');
        }, 500);
      } else {
        MessageAlert.error('순서 변경 중 오류가 발생하였습니다.');
      }
    } catch (err) {
      console.error('[handleSubmit] Error!! ', err);
      MessageAlert.error('순서 변경에 실패하였습니다.');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 4000);
    }
  };
  return (
    <>
      <Content
        maxWidth="100%"
        borderRadius={4}
        padding={20}
        style={{ height: '100%' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12,
          }}
        >
          <h4 style={{ fontSize: 14, fontWeight: 500 }}>
            검색 결과 총 <span>{searchWordList?.length}</span>건
          </h4>
          <Button
            style={{ marginRight: 5 }}
            onClick={() => onModal('sort', searchWordList)}
          >
            순서변경
          </Button>
        </div>
        <List
          itemLayout="horizontal"
          dataSource={searchWordList}
          renderItem={(item) => (
            <ListItem
              key={item.search_word_id}
              isActive={
                selectedSearchWord &&
                selectedSearchWord.search_word_id === item.search_word_id
                  ? true
                  : false
              }
              onClick={() => handleClickSearchWord(item)}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div>
                  <div>{item.search_word}</div>
                  <div style={{ fontSize: '12px', color: 'gray' }}>
                    {item.is_show === 'Y' ? (
                      <Tag color="success">노출</Tag>
                    ) : (
                      <Tag color="default">미노출</Tag>
                    )}
                    &nbsp;
                    {moment.unix(item.updated_at).format('YYYY-MM-DD')}
                  </div>
                </div>
                <div>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => handleUpdateSearchWord(item)}
                  />
                  &nbsp; &nbsp;
                  <Button
                    size="small"
                    icon={<DeleteOutlined />}
                    danger
                    onClick={() => handleDeleteSearchWord(item)}
                  />
                </div>
              </div>
            </ListItem>
          )}
        />
        <SearchWordModifyPopup
          isOpen={modifyPopupInfo.isOpen}
          setModifyPopupInfo={setModifyPopupInfo}
          defaultData={modifyPopupInfo.defaultData}
          searchWordList={searchWordList}
          onClose={() =>
            setModifyPopupInfo({ isOpen: false, defaultData: null })
          }
        />
      </Content>

      {/* 모달 */}
      <ModalLayout
        type={'modal'}
        open={modalType && modalType === 'SORT'}
        onCancel={() => onModal('close')}
        centered
        closable
        width={500}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Flex justify="flex-end">
                  <Button
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() => handleSubmit(dataList)}
                  >
                    저장
                  </Button>
                </Flex>
              </Col>
            </Row>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'20px 0'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Flex vertical gap={12} style={{ padding: '12px 0px' }}>
                  {/* 헤더 추가 */}
                  <Flex
                    justify="space-between"
                    align="center"
                    style={{
                      fontWeight: 700,
                      borderBottom: '1px solid #ddd',
                      paddingBottom: '8px',
                    }}
                  >
                    <Text style={{ width: '20%', textAlign: 'center' }}>
                      검색어 ID
                    </Text>
                    <Text style={{ width: '50%', textAlign: 'center' }}>
                      검색어
                    </Text>
                    <Text style={{ width: '30%', textAlign: 'center' }}>
                      순서 변경
                    </Text>
                  </Flex>

                  {/* 리스트 출력 */}
                  {dataList
                    ?.sort((a, b) => a?.order - b?.order)
                    ?.map((_item, _index) => (
                      <Flex
                        key={`banner-${_item.search_word_id}`}
                        justify="space-between"
                        align="center"
                        style={{ padding: '4px 0' }}
                      >
                        <Text
                          weight={700}
                          style={{ width: '20%', textAlign: 'center' }}
                        >
                          {_item?.search_word_id}
                        </Text>
                        <Text
                          weight={700}
                          style={{ width: '50%', textAlign: 'center' }}
                        >
                          {_item?.search_word}
                        </Text>
                        <Select
                          style={{ width: '80px' }} // ✅ 셀렉트 박스 크기 조정
                          value={_index}
                          options={Array.from(
                            { length: dataList.length },
                            (_, index) => ({
                              label: `${index + 1}번`,
                              value: index,
                            })
                          )}
                          onChange={(e) => {
                            const newArray = [...dataList];
                            const [movedItem] = newArray.splice(_index, 1);
                            newArray.splice(e, 0, movedItem);

                            const newOrderArray = newArray.map(
                              (item, index) => ({
                                ...item,
                                order: index + 1,
                              })
                            );
                            setDataList(newOrderArray);
                          }}
                        />
                      </Flex>
                    ))}
                </Flex>
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

const ListItem = styled(List.Item)`
  cursor: pointer;
  border: 1px solid #d8d8d8 !important;
  border-radius: 10px;
  padding: 20px 10px !important;
  margin-bottom: 5px;

  &:hover {
    background-color: #e5f2ff;
  }

  background-color: ${({ isActive }) => (isActive ? '#e5f2ff' : 'none')};
`;

export default SearchWordList;
